import { PublicSiteInformation, QuirkCommunity } from 'model';
import styles from './CommunityItem.module.css';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import GenericAboutIcon from '../assets/abouticon_default.png';
import { IonText } from '@ionic/react';
import { HttpRequest } from '../App.js';
import { IconCheck } from './QuirkIcons/index.js';
import { SkeletonLoader } from './SkeletonLoader.js';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { QuirkImage } from './QuirkImage.js';

interface CommunityItemProps {
	item: QuirkCommunity;
	current?: boolean;
	onSelect: (community: QuirkCommunity) => void | Promise<void>;
	key?: string;
}

async function getCommunityImageInfo(base: string): Promise<PublicSiteInformation> {
	const resp = await HttpRequest({ url: `${base}/api/siteSettings/info`, method: 'GET' });
	if (resp.status >= 400) {
		throw new Error(`error recieved status ${resp.status}`);
	}
	return await resp.data;
}

export function CommunityItem({ item, current, onSelect, key }: CommunityItemProps) {
	const [info, setInfo] = useState<PublicSiteInformation | undefined | null>(undefined);
	const [error, setError] = useState<Error>();
	const { location, hostname } = item;
	const lightIcon = info?.lightIcon ? `${item.hostname}/api/siteSettings/image/${info?.lightIcon}` : GenericAboutIcon;
	const darkIcon = info?.darkIcon ? `${item.hostname}/api/siteSettings/image/${info?.darkIcon}` : GenericAboutIcon;
	useEffect(() => {
		if (!info && !error) {
			getCommunityImageInfo(hostname).then(setInfo).catch(setError);
		}
	}, [info, hostname, error]);
	const onClick = () => {
		if (!current) {
			onSelect?.(item);
		}
	};
	return (
		<div className={classNames(styles.CommunityItem)} onClick={onClick} key={key}>
			<div className={styles.info}>
				<span className={styles.name}>
					{info?.siteName ?? item.name}
					{current && (
						<span className={styles.current}>
							<IconCheck />
						</span>
					)}
				</span>
				<span className={styles.location}>{location}</span>
			</div>
			<SkeletonLoader height={100}>
				{info || error ? (
					<div className={styles.imageDescription}>
						<div className={styles.image}>
							<QuirkImage
								className={classNames(sharedStyles.lightmode)}
								src={lightIcon}
								alt={info?.siteName ?? item.name}
								fallback={GenericAboutIcon}
							/>
							<QuirkImage
								className={classNames(sharedStyles.darkmode)}
								src={darkIcon}
								alt={info?.siteName ?? item.name}
								fallback={GenericAboutIcon}
							/>
						</div>
						<div>
							{info?.description}
							{info && !info.description && <IonText color="warning">No description given.</IonText>}
							{!info && error && <IonText color="danger">Error loading description.</IonText>}
						</div>
					</div>
				) : null}
			</SkeletonLoader>
		</div>
	);
}
